import { isNil } from 'ramda';
import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation VerifyLateEditTokenMutation($token: String!, $externalId: String!, $documentId: String!) {
    verifyLateEditToken(token: $token, externalId: $externalId, documentId: $documentId) {
      ok
      error
    }
  }
`;

export default (token, externalId, documentId, done) => {
  const variables = {
    token,
    externalId,
    documentId
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ verifyLateEditToken: { ok, error } }) => {
        if (!isNil(done)) done(ok, error);
      },
      onError: error => onErrorMutation(error, done)
    }
  );
};
